<template>
  <icon-default :icon="isActiveSortIcon" @click="changeSort"/>
</template>

<script>

import IconDefault from "@/components/shared/IconDefault.vue";
export default {
  name: "IconArrowSort",
  components: {
    IconDefault,},
  props: {
    activeSort: {
      type: String,
      default: 'DEFAULT'
    }
  },
  computed: {
    isActiveSortIcon() {
      return this.activeSort === 'desc'
          ? 'sort/desc'
          : this.activeSort === 'asc'
              ? 'sort/asc'
              : 'sort/default'
    }
  },
  methods: {
    changeSort() {
      let value = 'default'
      switch (this.activeSort) {
        case 'default':
          value = 'asc'
          break;
        case 'asc':
          value = 'desc'
          break;
        case 'desc':
          value = 'default'
          break;
      }
      this.$emit('changeSort', value)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
